import useDelivery from '@/useDelivery';

const { english: shipmentStatus, mapStatusToTracking } = useDelivery();

export default function useDeliveryNoteStatus() {
  const english = [
    'PREPARE_TO_DELIVER',
    'ON_THE_WAY',
    'UNSUCCESS',
    'SUCCESS',
    // 'HAS_CANCELED_ORDER',
  ];

  const thai = [
    'เตรียมส่งสินค้า',
    'อยู่ระหว่างการส่ง',
    'ส่งสินค้าไม่สำเร็จ',
    'ส่งสินค้าสำเร็จ',
    // 'มีรายการถูกยกเลิก',
  ];

  const translate = (status: string) => thai[english.indexOf(status)];

  const deliveryNoteStatusClassMap = (status: string) => {
    switch (status) {
      case 'PREPARE_TO_DELIVER':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'ON_THE_WAY':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-primary-600';
      case 'SUCCESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      case 'UNSUCCESS':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'HAS_CANCELED_ORDER':
        return 'block text-gray-600 rounded-xl text-xs py-1 text-center bg-gray-300';
      default: return '';
    }
  };

  function deliveriesStatusToDeliveryNoteStatus(deliveries: { status: string }[]) {
    const deliveriesStatus: number[] = [];
    // eslint-disable-next-line
    deliveries?.forEach((delivery: { status: string }) => {
      deliveriesStatus.push(shipmentStatus.indexOf(delivery.status));
    });
    const deliveryNoteStatusIndex = Math.min(...deliveriesStatus);
    switch (deliveryNoteStatusIndex) {
      // ON_THE_WAY
      case 3:
      case 4:
      case 5:
        return english[1];
      // UNSUCCESS
      case 6:
      case 7:
        return english[2];
      // SUCCESS
      case 8:
        return english[3];
      // --- Deprecated ---
      // HAS_CANCELED_ORDER
      // case 4:
      //   return english[4];
      // -------------------
      // PREPARE_TO_DELIVER
      default:
        return english[0];
    }
  }

  return {
    english,
    thai,
    translate,
    deliveryNoteStatusClassMap,
    deliveriesStatusToDeliveryNoteStatus,
  };
}
